import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'

export class ProfileService {
    private appShortcode: HTMLElement
    private appType: string
    private URLPath: string

    private DOM = {
        class: {
            appLoader: 'app-loader',
            profileShortcode: 'postmedia-profile-shortcode',
        },
        dataAppContainer: 'data-app-container',
        dataAppPath: 'data-app-path'
    }

    constructor() {
        this.initialize().then(() => {
            logger('debug', `Initialize Profile Service App`)
        }).catch(() => {
            logger('error', `Profile Service App not initialized`)
        })
    }

    /**
     * Initialize Profile Service
     */
    public async initialize() {
        await DOMUtils.ready

        let appPath: string
        this.appShortcode = document.querySelector(`.${this.DOM.class.profileShortcode}`)

        if (this.appShortcode) {
            this.appType = this.appShortcode.getAttribute(`${this.DOM.dataAppContainer}`)
            appPath = this.appShortcode.getAttribute(`${this.DOM.dataAppPath}`)

            if (appPath) {
                this.URLPath = `${appPath}/static/js/main.js`
            }

            if (this.URLPath && this.appType) {
                try {
                    await this.addLoader()
                    logger('debug', `Profile service loader added`)
                    this.loadAppScript()
                    this.removeLoader()
                } catch(e) {
                    logger('error', `Profile service loader not added: ${e}`)
                }
            }
        }
    }

    /**
     * Load profile service script
     */
    private loadAppScript() {
        DOMUtils.loadScript(this.URLPath)
        logger('debug', `Load Profile Service App script ${this.URLPath}`)
    }

    /**
     * Add a loader
     */
    private async addLoader() {
        const loader = document.createElement('div')
        loader.className = `${this.DOM.class.appLoader}`

        if (this.appShortcode) {
            this.appShortcode.appendChild(loader)

            // add styles
            const scss = import('./styles/profile-service.scss')
            DOMUtils.addStyles((await scss).default)
        }
    }

    /**
     * Remove loader
     */
    private removeLoader() {
        const loader = document.querySelector(`.${this.DOM.class.appLoader}`)
        if (loader) {
            loader.remove()
        }
    }
}
